import { SearchObject } from "app/common/Model/SearchObject";
import { searchPatientServiceRegisterReport } from "app/services/PatientServiceRegisterService";
import { exportReportServiceItem } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportRegisterServiceStore {
  listDataReportService = null;
  searchReportService = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    getAllServiceInTreatment: true,
    getStaffRevenues: false,
    serviceId: null,
    serviceGroupId: null,
    phoneNumber: null,
    patientName: null,
    patientCode: null,
    listDepId: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportService = (searchReportService) => {
    this.searchReportService = {
      ...this.searchReportService,
      ...searchReportService,
    };
    this.pagingReportService();
  };

  pagingReportService = async () => {
    let {
      listDepId,
      serviceId,
      serviceGroupId,
      phoneNumber,
      patientName,
      patientCode,
      ...ortherData
    } = this.searchReportService;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!listDepId || listDepId.length === 0) {
      this.listDataReportService = null;
      return;
    }
    
    if (listDepId) {
      ortherData.listDepId = listDepId?.map((el) => el?.id);
    }
    if (serviceId) {
      ortherData.serviceId = serviceId?.id;
    }
    if (serviceGroupId) {
      ortherData.serviceGroupId = serviceGroupId?.id;
    }
    if (phoneNumber) {
      ortherData.phoneNumber = phoneNumber;
    }
    if (patientName) {
      ortherData.patientName = patientName;
    }
    if (patientCode) {
      ortherData.patientCode = patientCode;
    }
    return await searchPatientServiceRegisterReport({ ...ortherData })
      .then(({ data }) => {
        this.listDataReportService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu dịch vụ có lỗi");
      });
  };

  handleExportRegisterService = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportReportServiceItem(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DANG_KI_DICH_VU.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { listDepId, ...rest } = rawSearch;
    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id) || null,
    };
  };

  resetStore = () => {
    this.listDataReportService = null;
    this.listDataReportService = null;
    this.searchReportService = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      getAllServiceInTreatment: true,
      getStaffRevenues: false,
      serviceId: null,
      serviceGroupId: null,
      phoneNumber: null,
      patientName: null,
      patientCode: null,
      listDepId: null,
    };
  };
}
